<template>
  <div class="home-page login-content" style="padding-top: 0;">
		<div class="login login-send">
		  <div class="">
		    <div class="home-prize ac">
		      <div class="home1">
		          <div class="pt20">
		            <a class="logo" style="text-align: left;margin:0 auto 30px;position: relative;width: 140px;" @click="getToNav()"><img src="static/images/logo.png" /></a>
		          </div>
		      </div>
          <img style="width: 100%;margin: -180px 0;" src="../../static/images/login-img.png" />
		    </div>
		    <div class="input-div" style="margin-top: -50px;">
		      <div class="fs50 crfff mt30" style="width: 90%;margin:0 auto" v-html="$t('Login')"></div>
		      <div class="span mt20 fs33 crfff fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('loginTips')}}</div>
		      <div class="input-item mt20">
		        <div class="input-item2">
		          <span class="app-en fs33" style="padding: 0 20px;">09</span>
		          <input class="input" v-model="mobile" type="number" placeholder="">
		        </div>
		      </div>
		    </div>

		    <div class="ac mt20">
		      <div class="span fs26 ac fw7" style="font-weight: 400;margin-bottom: 10px;">{{$t('select')}}</div>
		      <div class="drown-list login-list">
		        <div class="drown-li" @click="goLogin()">
		          <div class="day btn-green" >
		            <span>{{$t('Login')}}<img style="margin-left: 5px;" src="../../static/images/re.png" /></span>
		          </div>
		        </div>
		      </div>
		    </div>
		    <div class="ac otp-b disflex mt100">
		      <div class="icon icon2 fw7" @click="push('termsAndCondition2')">{{$t('TC')}} <span class="app-en">>></span></div>
		      <div class="icon icon2 fw7" @click="push('faq2')">{{$t('FAQ')}} <span class="app-en">>></span></div>
		    </div>
		  </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',
        type:'daily',
      }
    },
	created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    let that = this
    if (this.$route.query.mobile){
      that.mobile = this.$route.query.mobile;
    }
    if (this.$route.query.type){
      that.type = this.$route.query.type;
    }
	},
  methods: {
      getToNav(url){
        this.$router.push({path:'/'});
      },
      push(path){
        this.$router.push({path:path});
      },
      back(){
        this.$router.go(-1);
      },
		  goLogin(){
        let that = this
        if(!this.mobile){
          that.$utils.alertText(that.$t('loginTips'),80)
        }else{
          this.checkMobile();
          // this.testLogin()
        }
		},
    checkMobile(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let data = {
        "mobile":mobile
      }
      //检测号码
      that.$api.post('/api/user/check_user',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.$router.push({path:'/'})
        }else if(r.code==-1){
          this.startSub()
        } else{
          that.$utils.alertText(r.msg,100,2000);
        }
      })
    },
    //直接订阅登录
    startSub(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let type  = this.type
      let queryParams = this.$route.query;
      delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
      delete queryParams.type; // 删除 type，避免 URL 里重复
      let queryString = Object.keys(queryParams).length
        ? '&' + Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
        : '';
      let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code === 1){
            that.$parent.returnCode(r,function(){
              localStorage.setItem('token',r.data.userinfo.token)
              localStorage.setItem('mobile',r.data.userinfo.mobile)
              that.$router.push('/');
            });
          }else{
            that.$utils.alertText(r.msg,80, 2000);
          }
        });
      })
    },
    //测试阶段任意号码直接登录
    testLogin(){
      let that = this
      let mobile = this.mobile
      that.$parent.loadModal(true);
      let url = '/api/user/test_login'
      let data = {
        mobile:mobile
      }
      that.$api.post(url,data,r =>{
        that.$parent.loadModal(false);
        if(r.code === 1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.$router.push({path:'/'})
          //window.location.href = r.data;
        }else{
          that.$utils.alertText(r.msg,80);
        }
      })
    }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .mt100{margin-top:100px;}
  .otp-b{justify-content: space-evenly;}
  .drown-li{min-width:320px;}
  .drown-li + .drown-li{margin-left: 30px;}
  .drown-li + .drown-li .disflex{background: #0065f3;}
  .drown-li .day>span{padding:26px 20px}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue